module.exports = __webpack_public_path__ + "img/basics.8a80f3aa.png";